import React from 'react'
import classNames from 'classnames'

interface IProps {
  width?: number
  height?: number
  className?: string
}

const FontSize10: React.FC<IProps> = ({
  width,
  height,
  className,
  children,
}) => {
  return (
    <React.Fragment>
      <span
        className={classNames('text-wrapper', className)}
        style={{ width, height }}
      >
        <span className={`font-size-10`}>{children}</span>
      </span>
      <style jsx global>
        {`
          .text-wrapper {
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }
          .font-size-10 {
            font-size: 16px;
            transform: scale(0.625);
            white-space: nowrap;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default FontSize10
